<div class="form-panel__body" [formGroup]="form">

  <!-- ── Your question ─────────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.question">
    <div class="query-section__header" (click)="toggleSection('question')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="question"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Your question</span>
          <span class="query-section__desc">What you're asking</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.question ? 'flex' : 'none'">


      <div class="form-field">
        <label class="form-field__label">Question<span class="form-field__required">*</span></label>
        <textarea class="field-textarea" formControlName="question" placeholder="e.g. List contracts awarded to FN Herstal since 1 January 2025"></textarea>
        <!-- Written for direct mode; the mode switch is under Response configuration. -->
        @if (form.value.mode === 'direct') {
          <div class="question-row">
            <!-- Shared by the dropdown below and, on phones, the help sheet. -->
            <ng-template #helpRows>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">1</span>
                <div class="operators-help__text">
                  <p>For questions requiring comprehensive results, ask only one question at a time.</p>
                </div>
              </div>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">2</span>
                <div class="operators-help__text">
                  <p>Phrase your question in natural language, avoiding Boolean operators, and ensure correct syntax whenever possible.</p>
                </div>
              </div>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">3</span>
                <div class="operators-help__text">
                  <p>Using English is recommended for the best results.</p>
                </div>
              </div>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">4</span>
                <div class="operators-help__text">
                  <p>Make sure your question is precise and focuses on a single topic or fact.</p>
                </div>
              </div>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">5</span>
                <div class="operators-help__text">
                  <p>Although not mandatory, it is advisable to place named entities in quotation marks.</p>
                  <code>"Nestlé", "Ulf Kristersson"</code>
                </div>
              </div>
              <div class="operators-help__row">
                <span class="operators-help__badge operators-help__badge--syntax">6</span>
                <div class="operators-help__text">
                  <p>Include instructions on how the answer should be generated or formatted only within <code>[[ ]]</code>, and keep these instructions brief.</p>
                  <code>[[Present the answer as a bulleted list]]</code>
                </div>
              </div>
            </ng-template>
            <div class="dropdown" (appClickOutside)="closeTips()">
              <button type="button" class="link question-tips__link" [attr.aria-expanded]="tipsOpen" (click)="toggleTips($event)">Tips for using the direct mode</button>
              @if (tipsOpen) {
                <div class="operators-help question-tips dropdown__menu dropdown__menu--left">
                  <p class="operators-help__title">Tips for using the direct mode</p>
                  <ng-container [ngTemplateOutlet]="helpRows" />
                </div>
              }
            </div>
          </div>
        }
        <!-- Prompt Optimizer link disabled until the feature is complete
             restore this button (and its RAG counterpart) once it's ready. -->
        <!--
        <button type="button" class="link form-field__link" style="background:none;border:none;padding:0;font-family:inherit;text-align:left;" [disabled]="!form.value.question?.trim()" (click)="openPromptOptimizer()">Perfect your prompt with our Prompt Optimizer</button>
        -->
      </div>

    </div>
  </div>

  <!-- ── Request configuration ────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.request">
    <div class="query-section__header" (click)="toggleSection('request')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="request"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Request configuration</span>
          <span class="query-section__desc">What gets searched content filters, dates, domains</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.request ? 'flex' : 'none'">

      @if (isCikisiUser) {
      <div class="cikisi-block">
        <div class="form-section__toggle-row">
          <label class="cikisi__toggle">
            <input type="checkbox" class="cikisi__input" formControlName="cikisiOnly">
            <span class="toggle__track"><span class="toggle__thumb"></span></span>
          </label>
          <div class="form-section__toggle-info">
            <span class="form-sublabel">Search only Cikisi content</span>
            <div class="form-section__status">
              <span class="status-dot status-dot--green"></span>
              <span class="form-hint">Connected</span>
              <span class="form-hint">sk-cikisi-••••••••••••••••••4f2a</span>
            </div>
          </div>
        </div>
        <div class="filter-rows">
          <p class="filter-rows__label">Filter cikisi content by</p>

          <!-- Its own on/off row, a sibling of Knowledge Topics below
               rather than folded into it (see toggleKnowledgeBase()) no
               body of its own since there's nothing to pick, just whether
               the whole knowledge base is in scope. -->
          <div class="filter-row" [class.filter-row--on]="form.value.knowledgeBase">
            <div class="filter-row__header" (click)="toggleKnowledgeBase()">
              <span class="filter-row__check" [class.filter-row__check--on]="form.value.knowledgeBase"></span>
              <span class="filter-row__label">Knowledge Base</span>
            </div>
          </div>

          @for (rowCtrl of filterRowsArray.controls; track rowCtrl; let i = $index) {
            <div
              class="filter-row"
              [class.filter-row--on]="rowCtrl.value.expanded"
              [class.filter-row--disabled]="FILTER_ROW_META[i].id === 'a-kt' && form.value.knowledgeBase"
            >
              <div class="filter-row__header" (click)="onFilterRowHeaderClick(FILTER_ROW_META[i], rowCtrl)">
                <span class="filter-row__check" [class.filter-row__check--on]="rowCtrl.value.expanded"></span>
                <span class="filter-row__label">{{ FILTER_ROW_META[i].label }}</span>
                <span class="filter-row__count" [class.filter-row__count--inactive]="!rowCtrl.value.expanded">{{ rowChipCount(rowCtrl) > 0 ? rowChipCount(rowCtrl) + ' selected' + (!rowCtrl.value.expanded ? ' (not applied)' : '') : '' }}</span>
                <svg class="filter-row__chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              @if (FILTER_ROW_META[i].kind === 'flat') {
                <div class="filter-row__body" [style.display]="rowCtrl.value.expanded ? 'block' : 'none'">
                  <mila-multi-select
                    [formControl]="rowSelectControlOf(rowCtrl)"
                    [fetchPage]="flatFetchers[FILTER_ROW_META[i].id]"
                    [placeholder]="FILTER_ROW_META[i].placeholder"
                  ></mila-multi-select>
                </div>
              }
            </div>
          }
        </div>
      </div>
      }

      <div class="form-field form-field--narrow">
        <label class="form-sublabel">Published between</label>
        <div class="form-field__date-row">

          <div class="date-picker-wrap" (appClickOutside)="closeCal(calFrom)">
            <div class="field-input field-input--date" (click)="toggleCal(calFrom, $event, 'Published from')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calFrom) || 'From' }}</span>
              @if (calFrom.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calFrom, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calFrom.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calFrom, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calFrom.month] }} {{ calFrom.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calFrom, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calFrom); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calFrom, day)"
                         [class.cal-day--today]="isToday(calFrom, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calFrom, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>

          <div class="date-picker-wrap" (appClickOutside)="closeCal(calTo)">
            <div class="field-input field-input--date" (click)="toggleCal(calTo, $event, 'Published to')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calTo) || 'To' }}</span>
              @if (calTo.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calTo, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calTo.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calTo, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calTo.month] }} {{ calTo.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calTo, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calTo); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calTo, day)"
                         [class.cal-day--today]="isToday(calTo, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calTo, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>

        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Include domains</label>
        <div class="field-input field-input--tag">
          @for (chip of includeChipsArray.controls; track $index; let i = $index) {
            <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeDomainChip(includeChipsArray, i)">×</span></span>
          }
          <input type="text" class="filter-chip-input__field" placeholder="e.g. skanska.com" (keydown)="onDomainKey($event, includeChipsArray)">
        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Exclude domains</label>
        <div class="field-input field-input--tag">
          @for (chip of excludeChipsArray.controls; track $index; let i = $index) {
            <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeDomainChip(excludeChipsArray, i)">×</span></span>
          }
          <input type="text" class="filter-chip-input__field" placeholder="e.g. google.com" (keydown)="onDomainKey($event, excludeChipsArray)">
        </div>
      </div>

      <div class="form-field">
        <label class="form-sublabel">Language search</label>
        <mila-multi-select
          formControlName="languageSearch"
          [fetchPage]="languageFetcher"
          sheetTitle="Languages"
          placeholder="Search languages…"
        ></mila-multi-select>
      </div>

    </div>
  </div>

  <!-- ── Response configuration collapsed by default: set once, rarely revisited ── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.response">
    <div class="query-section__header" (click)="toggleSection('response')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="response"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Response configuration</span>
          <span class="query-section__desc">How the answer is generated and shaped</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.response ? 'flex' : 'none'">

      <div class="form-field">
        <label class="form-field__label">Mode</label>
        <div class="seg-control">
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.mode === 'direct'" (click)="setMode('direct')">
            <div class="seg-control__title">
              <svg class="seg-control__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9.5 2.5C9.5 1.67157 8.82843 1 8 1C7.17157 1 6.5 1.67157 6.5 2.5C6.5 3.32843 7.17157 4 8 4C8.82843 4 9.5 3.32843 9.5 2.5Z" fill="currentColor"/>
                <path d="M5.5 12.5L6.5 8H4L5 5H11L12 8H9.5L10.5 12.5C10.5 13.3284 9.32843 14 8 14C6.67157 14 5.5 13.3284 5.5 12.5Z" fill="currentColor"/>
              </svg>
              Direct
            </div>
            <div class="seg-control__desc">Performs a single search to generate an answer to a simple question</div>
          </div>
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.mode === 'reasoning'" (click)="setMode('reasoning')">
            <div class="seg-control__title">
              <svg class="seg-control__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2 5.75C2 5.33579 1.66421 5 1.25 5C0.835786 5 0.5 5.33579 0.5 5.75V6.5C0.5 8.57107 2.17893 10.25 4.25 10.25H7.44L6.22 11.47C5.92711 11.7629 5.92711 12.2371 6.22 12.53C6.51289 12.8229 6.98711 12.8229 7.28 12.53L9.78 10.03C10.0729 9.73711 10.0729 9.26289 9.78 8.97L7.28 6.47C6.98711 6.17711 6.51289 6.17711 6.22 6.47C5.92711 6.76289 5.92711 7.23711 6.22 7.53L7.44 8.75H4.25C3.00736 8.75 2 7.74264 2 6.5V5.75Z" fill="currentColor"/>
              </svg>
              Reasoning
            </div>
            <div class="seg-control__desc">Performs multiple searches sequentially to generate an answer requiring reasoning</div>
          </div>
        </div>
      </div>

      <div class="form-field">
        <label class="form-field__label">Output type</label>
        <div class="seg-control">
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.outputType === 'unstructured'" (click)="setOutputType('unstructured')">
            <div class="seg-control__title">Unstructured</div>
            <div class="seg-control__desc">Natural language</div>
          </div>
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.outputType === 'structured'" (click)="setOutputType('structured')">
            <div class="seg-control__title">Structured</div>
            <div class="seg-control__desc">JSON format</div>
          </div>
        </div>
      </div>

      @if (form.value.outputType === 'structured') {
        <div class="form-field">
          <div class="form-field__label-row">
            <span class="form-sublabel">Response schema</span>
            <span class="badge badge--green">Only for Structured output</span>
          </div>
          <div class="schema-editor">
            <div class="schema-editor__toolbar">
              <span class="schema-editor__lang">JSON Schema</span>
              <button class="schema-editor__gen-btn">Generate from question</button>
            </div>
            <pre class="schema-editor__code">{{'{'}}
  "type": "object",
  "properties": {{'{'}}
    "company": {{'{'}} "type": "string" {{'}'}},
    "year": {{'{'}} "type": "string" {{'}'}},
    "amount": {{'{'}} "type": "number" {{'}'}}
  {{'}'}}
{{'}'}}</pre>
          </div>
        </div>
      }

    </div>
  </div>

</div>
